/**
 * 입고작업 2.0(GL17) API — moms-be 2.0 API 만 부른다(1.0 `/api/grid/*`·`/api/common/*` 0건).
 *
 * | 동작        | 1.0                                              | 2.0                                                  |
 * |-------------|--------------------------------------------------|------------------------------------------------------|
 * | 송장 스캔   | `POST /api/grid/search`(GL09_HEAD) → 2.0 scan     | `POST /api/v1/global/inbound-works/scan`              |
 * | 첨부 업로드 | `/api/common/resource` POST·`/api/common/s3`     | `POST /api/v1/common/file/uploads`(준비) + S3 PUT      |
 * | 첨부 완료   | `/api/common/resource` PATCH·`/api/grid/save`    | `PATCH /api/v1/global/inbound-works/attachments`(16057) |
 *
 * 공통 완료 API(`PATCH /api/v1/common/file/uploads`)는 반품 전용이라 부르지 않는다. 완료는 업무 API 가 key 를 받아
 * `MOMS_FILE_INFO` 생성과 스캔 이력 연결을 한 트랜잭션으로 한다(위키 739606732 「첨부파일 S3 구조」 3장).
 */
import request from '@/utils/request'
import { putCommonFileObject } from '@/services/commonFile/apis'
import { GLOBAL_INBOUND_SHIPPER, INBOUND_WORK_MENU_CODE } from '../consts'
import type { InboundAttachmentSaveReq, InboundAttachmentSaveRes, InboundScanReq, InboundScanRes } from './types'

export const INBOUND_SCAN_URL = '/api/v1/global/inbound-works/scan'
export const INBOUND_ATTACHMENTS_URL = '/api/v1/global/inbound-works/attachments'

/** 송장·특수 바코드 스캔 — 판정·이력 적재·상태 전이·라벨 데이터가 한 번에 온다. */
export const scanInboundInvoice = (body: InboundScanReq) => request.post<ApiResponseV2<InboundScanRes>, InboundScanReq>(INBOUND_SCAN_URL, body)

/** 첨부 완료 — 올린 key 들로 파일 정보를 만들고 원본송장의 최신 스캔 이력 FILE_ID 에 덧붙인다(1.0 `GL09_UpdateForm`). */
export const saveInboundAttachments = (body: InboundAttachmentSaveReq) =>
  request.patch<ApiResponseV2<InboundAttachmentSaveRes>, InboundAttachmentSaveReq>(INBOUND_ATTACHMENTS_URL, body)

/** 첨부 하나를 S3 에 올리고 완료 API 에 넘길 key 를 돌려준다. 실패는 `CommonFileUploadError` 로 던진다. */
export const uploadInboundFile = async (file: Blob, fileName: string): Promise<string> => {
  const named = file instanceof File ? file : new File([file], fileName, { type: file.type })
  return putCommonFileObject(INBOUND_WORK_MENU_CODE, GLOBAL_INBOUND_SHIPPER, named)
}
